import { call, put } from 'redux-saga/effects';
import {
  downloadOrganisationAttachmentFailure,
  downloadOrganisationAttachmentSuccess,
} from '../actions';
import {
  downloadOrganisationAttachment,
  DownloadOrganisationAttachmentResponse,
} from '../api';

import { DownloadOrganisationAttachmentRequestAction } from '../types';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { checkResponse } from 'store/utils';
import { ApiError } from 'store/api/types';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* downloadOrganisationAttachmentSaga(
  action: DownloadOrganisationAttachmentRequestAction
) {
  try {
    let err: ApiError | null;
    const { organisationId, attachmentId } = action.payload;

    const response: DownloadOrganisationAttachmentResponse = yield call(
      downloadOrganisationAttachment,
      organisationId,
      attachmentId
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const fileName = response.data.fileName || '';
    const ext = fileName.split('.').pop()?.toLowerCase();
    let mimeType = '';
    switch (ext) {
      case 'jpg':
      case 'jpeg':
        mimeType = 'image/jpeg';
        break;
      case 'png':
        mimeType = 'image/png';
        break;
      case 'gif':
        mimeType = 'image/gif';
        break;
      case 'webp':
        mimeType = 'image/webp';
        break;
      case 'pdf':
        mimeType = 'application/pdf';
        break;
      default:
        mimeType = '';
    }

    const fileContent = response.data.file;
    let uint8Array: Uint8Array;
    if (typeof fileContent === 'string') {
      const base64ToUint8Array = (base64: string) => {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
      };
      uint8Array = base64ToUint8Array(fileContent);
    } else {
      console.warn('Unsupported fileContent type');
      yield put(downloadOrganisationAttachmentFailure());
      return;
    }

    const blob = mimeType //@ts-ignore
      ? new Blob([uint8Array], { type: mimeType }) //@ts-ignore
      : new Blob([uint8Array]);
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    yield put(downloadOrganisationAttachmentSuccess());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(downloadOrganisationAttachmentFailure());
  }
}
